import { combineReducers } from 'redux';

import aiReducer from 'redux/ai/reducer';
import userReducer from 'redux/users/reducer';
import courseReducer from 'redux/courses/reducer';
import applicationsReducer from 'redux/applications/reducer';
import formsReducer from 'redux/forms/reducer';
import groupsReducer from 'redux/groups/reducer';
import institutionReducer from 'redux/configurations/reducer';
import baseReducer from 'redux/base/reducer';
import adminLevelsReducer from 'redux/adminlevels/reducer';
import applicantsReducer from 'redux/applicants/reducer';
import workflowReducer from 'redux/workflow/reducer';
import workflow2Reducer from 'redux/workflow2/reducer';
import paymentConfigurationReducer from 'redux/payment-configuration/reducer';
import transactionHistoryReducer from './transaction-history/reducer';
import templateReducer from 'redux/template/reducer';
import dashboardReducer from 'redux/dashboard/reducer';
import filterReducer from 'redux/filters/reducer';
import umsUserManagementReducer from 'redux/ums-user-management/reducer';
import serviceWorkerReducer from 'redux/service-workers/reducer';
import candidateGroupReducer from 'redux/candidate-group/reducer';
import notificationReducer from 'redux/notifications/reducer';
import auditLogReducer from 'redux/audit-log/reducer';
import couponReducer from 'redux/coupon/reducer';
import directDownloadReducer from 'redux/direct-download/reducer';
import modificationLogReducer from './modification-log/reducer';
import addonsReducer from './addons/reducer';
import limitationReducer from './limitations/reducer';
import IntPaymentConfigReducer from './international-payment-configuration/reducer';
import tourReducer from './tours/reducer';

const rootReducer = combineReducers({
  base: baseReducer,
  applications: applicationsReducer,
  ai: aiReducer,
  limitation:limitationReducer,
  courses: courseReducer,
  forms: formsReducer,
  groups: groupsReducer,
  institutions: institutionReducer,
  newAdminLevels: adminLevelsReducer,
  users: userReducer,
  applicants: applicantsReducer,
  workflow: workflowReducer,
  workflow2: workflow2Reducer,
  payment: paymentConfigurationReducer,
  intPayments: IntPaymentConfigReducer,
  transaction: transactionHistoryReducer,
  template: templateReducer,
  statistics: dashboardReducer,
  serviceWorker: serviceWorkerReducer,
  filter: filterReducer,
  umsUser: umsUserManagementReducer,
  candidateGroup: candidateGroupReducer,
  notifications: notificationReducer,
  auditLog: auditLogReducer,
  coupons: couponReducer,
  downloads: directDownloadReducer,
  modificationLog: modificationLogReducer,
  addons: addonsReducer,
  tour: tourReducer,
});

export default rootReducer;
